import React, { memo, useLayoutEffect, useRef } from 'react';
import { Group, Mesh } from 'three';
import { useDataStore } from '../../zustand';
import { useGetSceneContent } from './trackerGroupHooks';

interface IPlacementSceneProps {
	sceneId: string;
}

const PlacementScene: React.FunctionComponent<IPlacementSceneProps> = ({ sceneId }) => {
	const groupRef = useRef<Group>(null);
	const componentsById = useDataStore((state) => state.componentsById);
	const sceneContent = useGetSceneContent(sceneId, componentsById, false)

	useLayoutEffect(() => {
		setTimeout(() => {
			groupRef.current?.traverse((node: any) => {
				if (node.isMesh) {
					const mesh = node as Mesh;
					const material = mesh.material;
					if (Array.isArray(material)) {
						material.forEach(m => {
							m.transparent = true;
							m.opacity = m.opacity * 0.7
							m.needsUpdate = true;
						})
					} else {
						material.transparent = true;
						material.opacity = material.opacity * 0.7;
						material.needsUpdate = true;
					}
				}
			});
		}, 50)
		
	}, [sceneId]);

	return (
		<group ref={groupRef} name="placement_scene">
			{sceneContent}
		</group>
	);
};

PlacementScene.displayName = 'PlacementScene';
export default memo(PlacementScene);
